import React, { useEffect } from "react"
import { useState } from "react"
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import { connect } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
// import { isChildWindow } from "../../../utils/Constants";
// import { TabActionEncounters } from "../../../../../../../actions/BillingActions";
import { OpenNewPatientTabAction, TabActionPatient } from '../../../../../../../actions/PatientActions';
import { isChildWindow } from "../../../../../../../utils/Constants";
import EncounterSearch from "../../EncounterSearch";
import EncounterRightPortion from "../EncounterRightPortion";
// import EncounterTab from './EncounterTab';

const EncounterRight = ({ templateDataToApply,setTemplateDataToApply, ...props}) => {
    let EncounterTab = props.OpenDynamicTab?.find(pat => pat.data.id === props?.patientID)?.Open_Encounter_Tab;
    let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    
    let dispatch = useDispatch();
    // const [filesView, setFilesView] = useState(false)
    const [recordsNum, setRecordsNum] = useState(false)
    const [tabList, setTabsList] = useState([{
        active: true,
        key: 2,
        name: "Encounter",
        data: {
            name: "All Encounter",
            id: 0,
            time: new Date()
        },
    }])

    const [activeTab, setActiveTab] = useState(0)
    useEffect(() => {
        if (EncounterTab && EncounterTab?.length > 0){
            console.log("EncounterTabAddDynamicTabDataitemtabList",EncounterTab)
            AddDynamicTabData(EncounterTab)
        } else {
            let obj = {
                active: true,
                key: 2,
                name: "Encounter",
                data: {
                    name: "All Encounter",
                    id: 0,
                    time: new Date()
                },
            }
            console.log("obj",obj)
            dispatch({
                type: 'Open_Encounter_Tab',
                payload: {
                  patientId: PatientIDR,     // <-- needed to find the patient tab to update
                  tab: obj            // the encounter tab object
                }
            });
        }

    }, [EncounterTab])
    // console.log("EncounterRight");
    const AddDynamicTabData = (data) => {
        console.log("AddDynamicTabDataitemtabList")
        let tabDataFromRedux = data.length > 0 ? data : [];
        const DataFromRedux = tabDataFromRedux.filter((ele) => { return ele.key === 2; });   // fetch only whose id is 2

        const activeElements = DataFromRedux.filter((row) => row.active === true); // get active 
        let firstEncounterTab = tabList.filter((el) => el.data.id === 0);
        let tabs = [...firstEncounterTab]
        // check if all pat exist in redux 
        const isExist = tabDataFromRedux.some((ele) => { return ele.key === 2 && ele.data.id === 0; });
        if (isExist) {
            setTabsList(DataFromRedux)
        } else {
            tabs = tabs.concat(...DataFromRedux)
            setTabsList(tabs)
        }
        setActiveTab(activeElements[0]?.data?.id)
    }
    // active tab 
    const handleActiveTab = (item) => {
        // if(isChildWindow) return;
        const { data } = { ...item }
        if (activeTab !== data?.id) {
            setActiveTab(data?.id)
        }

        if (item.data.id !== 0) {
            let obj = {
                key: 2,
                name: "Encounter",
                active: true,
                data: {
                    ...data,
                    time: new Date(),
                },
            };
            // dispatch(TabActionEncounters(obj));
            dispatch({
                type: 'Open_Encounter_Tab',
                payload: {
                  patientId: props?.patientID,     // <-- needed to find the patient tab to update
                  tab: obj            // the encounter tab object
                }
            });
        } else {
            let obj = {
                active: true,
                key: 2,
                name: "Encounter",
                data: {
                    name: "All Encounter",
                    id: 0,
                    time: new Date()
                },
            }
            dispatch({
                type: 'Open_Encounter_Tab',
                payload: {
                  patientId: PatientIDR,     // <-- needed to find the patient tab to update
                  tab: obj            // the encounter tab object
                }
            });
        }
    }
    // handle to close tab
    const handleCloseTab = async (id) => {
        if(tabList.length < 2) return;
        let index = tabList.findIndex((el) => el.data.id === id);
        tabList.splice(index, 1);
        let activTab =
            tabList.length > 0
                ? tabList[tabList.length - 1].data.id
                : 0;

        setTabsList(tabList)
        activeTab === id && setActiveTab(activTab)

        // props.TabActionEncounters({}, id);
        dispatch({
            type: 'Close_Encounter_Tab',
            payload: {
              patientId: props?.patientID,      // Replace with the actual patient's ID
              encounterId: id         // Replace with the encounter tab ID to close
            }
          });
    };
    // console.log("tabList",tabList)
    return (
        <div className='app-tabs fix-tabs'>
            <Nav className="rb-tabs bg-light-blue nav-tabs d-flex justify-content-between align-items-center ar-link">
                <div className="d-flex">
                    {tabList && tabList.map((item) => {
                        return (
                            <React.Fragment key={item.data.id}>
                                <NavItem >
                                    <NavLink
                                        href="#"
                                        className={activeTab === item.data.id ? "active" : ""}
                                        onClick={() => {
                                            handleActiveTab(item);
                                        }}
                                    >
                                        {item.data.id === 0 || item.data.id === -1 ? item.data.name : item.data.name}
                                    </NavLink>
                                    {item.data.id === 0 ? null :
                                        // isChildWindow ? <></> :
                                        <span onClick={() => handleCloseTab(item.data.id)} class="icon-cross-cricle fs-15"><span class="path1"></span><span class="path2"></span></span>
                                    }
                                    {item.data.id === 0 ?<div className="counter heading">{recordsNum}</div>: null}
                                </NavItem>
                            </React.Fragment>
                        )
                    })}
                </div>
                <>
                {/* {activeTab === 0 &&
                    <div className=" d-flex me-2 ar-toggle align-items-center">
                        <p className="heading me-4">Files View  </p>
                            <div class="pe-0 m-0 insurance_radio_btn mb-1">
                                <div class="form-check form-switch radio_button">
                                    <input class="form-check-input position-absolute" type="checkbox" id="filesView" name="filesView" autocomplete="off" checked={filesView} onChange={(e)=>setFilesView(e.target.checked)}/>
                                </div>
                            </div>
                    </div>} */}
                </>

            </Nav>

            <TabContent activeTab={activeTab}>
                {tabList &&
                    tabList.filter((el) => el.data.id === 0).map((item) => {
                        return (
                            <React.Fragment key={item.data.id}>
                                <TabPane tabId={item.data.id}>
                                    <EncounterSearch 
                                        // filesView={filesView} 
                                        // setFilesView={setFilesView}    
                                        setRecordsNum={setRecordsNum} 
                                        templateDataToApply={templateDataToApply} 
                                        setTemplateDataToApply={setTemplateDataToApply}
                                        {...props}
                                    />
                                </TabPane>
                            </React.Fragment>
                        )
                    })}
                {/* {console.log("itemtabListtabList",tabList)} */}

                {tabList &&
                    tabList.filter((el) => el.data.id !== 0).map((item) => {
                        // console.log("itemtabList1",item)
                        return (
                            <React.Fragment key={item.data.id}>
                                <TabPane tabId={item.data.id}>
                                    <div className="h-100" key={item.data.id}>
                                    {/* {console.log("itemtabList2",item)} */}
                                        {/* <EncounterSearch 
                                            Active={activeTab} 
                                            templateDataToApply={templateDataToApply} 
                                            setTemplateDataToApply={setTemplateDataToApply}
                                            {...props}/> */}
                                            
                                        <EncounterRightPortion
                                            Active={activeTab} 
                                            templateDataToApply={templateDataToApply} 
                                            setTemplateDataToApply={setTemplateDataToApply} 
                                            {...props}/>
                                    </div>
                                </TabPane>
                            </React.Fragment>
                        )
                    })}
            </TabContent>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        OpenDynamicTab: state.Open_Patient_Tab ? state.Open_Patient_Tab : [],
    };
}

const action = {
    TabActionPatient,
};
export default connect(mapStateToProps, action)(EncounterRight)


